<template>
  <div ref="text-bg-ctn"
       class="text-bg-ctn"
  >
    <div data-depth="0.2">
      <div ref="text-bg" class="text-bg" />
    </div>
  </div>
</template>
<script>
import Parallax from 'parallax-js'
import { TweenMax } from 'gsap'

export default {
  name: 'WelcomeBackgroundText',
  data () {
    return {
      parallax: undefined
    }
  },
  props: {
    visible: Boolean
  },
  methods: {
    shuffleArrayOrder (array) {
      let arr = array
      let currentIndex = arr.length
      let temporaryValue
      let randomIndex
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        temporaryValue = arr[currentIndex]
        arr[currentIndex] = arr[randomIndex]
        arr[randomIndex] = temporaryValue
      }
      return arr
    }
  },
  mounted () {
    const textBackground = this.$refs['text-bg']
    for (let i = 0; i < 75; i++) {
      let span = document.createElement('span')
      let text = document.createTextNode('Olá')
      span.appendChild(text)
      textBackground.appendChild(span)
      span.className = 'mr-3 opacity-0'
    }
    if (!this.$store.state.isMobile) {
      let textBackgroundContainer = this.$refs['text-bg-ctn']
      this.parallax = new Parallax(textBackgroundContainer)
    }
    // this.$root.$on('display-welcome-background', () => {
      let spanArr = textBackground.childNodes
      setTimeout(() => {
        spanArr.forEach((span, index) => {
          TweenMax.to(spanArr[index], 0.5, { opacity: 1, delay: index / 80 })
        })
      }, 500)
    // })
  }
}
</script>
<style scoped lang="sass">
  @tailwind utilities

  /* purgecss start ignore */
  $transition: .7s

  .text-bg-ctn
    @apply opacity-10 h-full
    width: calc(100vw + 200px)
    position: fixed !important
    @screen sm-l
      width: calc(100vw + 300px)
    @screen md
      width: calc(100vw + 300px)
    @screen lg
      width: calc(100vw + 500px)

  .text-bg
    @apply fixed pin-t pin-l flex flex-wrap font-sans
    left: 200px
    width: inherit
    font-size: 5.3rem
    line-height: 1
    @screen lg
      transform: none
    @screen md
      font-size: 7.0rem
    @screen lg
      font-size: 8.3rem

  /* purgecss end ignore */
</style>
